"use client";

import { CategoryData, CategorySelector } from "../feat.category-selector/category-selector.ui";

interface ClientCategoryProps {
  categoryData: CategoryData;
}

export const ClientCategory = (props: ClientCategoryProps) => {
  const { categoryData } = props;

  return (
    <CategorySelector
      data={categoryData}
      moduleType="Page"
    />
  );
};
